<template>
  <rest-page
    layout="tabbed"
    :loading="isLoading"
    :fetch-endpoint="fetchEndpoint"
  >
    <page-header-new :title="game.name" :breadcrumbs="breadcrumbs">
      <template #actions>
        <el-button type="primary" @click="createCampaignForGame">
          {{ $t('Gamification_Game_CreateGameCampaignBtn') }}
        </el-button>
      </template>
    </page-header-new>
    <page-tabs :tabs="tabs" />
  </rest-page>
</template>

<script>
import PageHeaderNew from '@/common/components/page/PageHeaderNew.vue'
import RestPage from '@/common/components/rest/RestPage.vue'
import { projectEndpoint, projectRoute } from '@/core/helpers'
import PageTabs from '@/common/components/page/PageTabs.vue'

export default {
  name: 'GameCampaignsPage',
  components: { PageTabs, RestPage, PageHeaderNew },
  data() {
    return {
      isLoading: false,
      game: {}
    }
  },
  computed: {
    breadcrumbs() {
      return [
        {
          label: this.$t('Gamification_GamesHub_Page_Title'),
          route: projectRoute({
            name: 'GamesHub'
          })
        },
        {
          label: this.game.name
        }
      ]
    },
    fetchEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: `games/${this.$route.params.id}`,
        params: { expand: 'gameRegions' },
        handler: data => {
          this.game = data
        }
      })
    },
    tabs() {
      return [
        {
          title: this.$t('Gamification_Game_Campaigns_Tab'),
          route: projectRoute({ name: 'GameCampaignsList' })
        },
        {
          title: this.$t('Gamification_Game_Configuration_Tab'),
          route: projectRoute({ name: 'GameCampaignsConfiguration' })
        }
      ]
    }
  },
  methods: {
    createCampaignForGame() {
      this.$router.push(projectRoute({ name: 'GameCreateCampaignPage' }))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/gamification/pages/GameCampaignsPage.vue